export default __webpack_public_path__ + "static/media/Memorabilia3.a0d53221.png";